import React from 'react';
import { PsPage } from '../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { DocumentUtils } from '../../shared/utils/DocumentUtils';
import { BreadcrumbsManagerInstance } from '../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../shared/breadcrumbs/Breadcrumbs';
import { DocumentDetailContent } from '../../documents/components/DocumentDetailContent';
import RouterUtils from '../../shared/routing/RouterUtils';
import { PsRoutes } from '../../shared/routing/Routes';
import { PsOutsource } from './shared/PsOutsource';
import { PsWorker } from './shared/PsWorker';

export class WorkerDocumentDetailScreen extends React.Component {

    constructor(init) {
        super(init);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_OUTSOURCES,
            Breadcrumbs.MY_OUTSOURCES_DETAIL,
            Breadcrumbs.WORKERS_EMPTY,
            Breadcrumbs.MY_OUTSOURCES_WORKERS_DETAIL,
            Breadcrumbs.DOCUMENTS_EMPTY,
            Breadcrumbs.MY_OUTSOURCES_OUTSOURCE_DOCUMENT_DETAIL,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;
        const { location, match } = this.props;
        const { documentId } = match.params;
        const title = I18nUtils.tr('TR_DOCUMENTO_DEL_TRABAJADOR_DE_MI_SUBCONTRATA');

        return (
            <PsPage
                title={title}
                location={location}
                breadcrumbs={breadcrumbs}
            >
                <DocumentDetailContent
                    documentId={documentId}
                    appendBreadcrumb={this.appendBreadcrumb}
                />
            </PsPage>
        );
    }

    appendBreadcrumb = (document) => {
        if (!document) {
            return;
        }

        const { location, match } = this.props;
        const { outsourceId, workerId } = match.params;
        const outsource = PsOutsource.fromAPICompany(document.company);
        const worker = PsWorker.fromAPIWorker(document.worker);

        BreadcrumbsManagerInstance.finishLoading({
            id: Breadcrumbs.MY_OUTSOURCES_DETAIL.id,
            url: RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_DETAIL, { id: outsourceId }),
            description: outsource.name(),
        });

        BreadcrumbsManagerInstance.finishLoading({
            id: Breadcrumbs.MY_OUTSOURCES_WORKERS_DETAIL.id,
            url: RouterUtils.generateRoute(PsRoutes.MY_OUTSOURCES_WORKERS_DETAIL, { outsourceId, workerId }),
            description: worker.completeName(),
        });

        BreadcrumbsManagerInstance.finishLoading({
            id: Breadcrumbs.MY_OUTSOURCES_OUTSOURCE_DOCUMENT_DETAIL.id,
            url: location.pathname,
            description: DocumentUtils.getDocumentName(document),
        });

        this.setState({
            breadcrumbs: [...BreadcrumbsManagerInstance.breadcrumbs()],
        });
    };
}

WorkerDocumentDetailScreen.propTypes = {};

WorkerDocumentDetailScreen.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-outsources/document/WorkerDocumentDetailScreen.jsx